import styled from "styled-components";
import { colors } from "../../styles/Variables";

export const ANoDecoration = styled.a`
    text-decoration: none;
`

export const Logo = styled.img`
    width: 10rem;
`

export const NavBarContainerDesktop = styled.div`
    display: flex;
    justify-content: space-evenly;
    background-color: ${({ backgroundColor }) => backgroundColor || colors.secondaryColor};
    align-items: center;
    height: 4rem;
    z-index: 9999;
    position: relative;
    box-shadow: ${({ isPro }) => isPro ? '0px 60px 160px rgba(0, 0, 0, 0.5)' : 'none'};

    @media (max-width: 768px) {
        display: none;
    }
`

export const NavBarContaineMobile = styled.div`
    display:none;

    @media (max-width: 768px) {
        display: flex;
        justify-content: space-evenly;
        background-color: #102051;
        align-items: center;
        padding: 0.5rem 0rem;
        box-shadow: ${({ isPro }) => isPro ? '0px 60px 160px rgba(0, 0, 0, 0.5)' : 'none'};
        z-index: 999;
        position: relative;
    }
`

export const NavBarContaineMobileEstacio = styled.div`
    display:none;

    @media (max-width: 768px) {
        display: flex;
        justify-content: space-evenly;
        background-color: #f1f1f1;
        align-items: center;
        padding: 0.5rem 0rem;
        box-shadow: ${({ isPro }) => isPro ? '0px 60px 160px rgba(0, 0, 0, 0.5)' : 'none'};
        z-index: 999;
        position: relative;
    }
`

export const LoginMobile = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
`
export const LoginMobileButton = styled.div`
    background-color: ${colors.ligthBlue};
    display: flex;
    justify-content: center;
    color: ${colors.white};
    font-weight: 800;
`
export const LoginMobilePerfil = styled.div`
    background-color: #348AC7;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 18px 6px;
    gap: 20px;
`

export const BoxIcon = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    border: 2px solid ${props => props.borderColor}; 
    border-radius: 10px; 
    padding: 10px; 
    margin: 5px; 
`

